import React, { useContext, useEffect, useState } from 'react';
import { Stack, StackItem, Icon, IconButton } from 'office-ui-fabric-react';
import { Formik } from 'formik';

import PrimaryButton from 'views/components/UI/Buttons/PrimaryButton';

import {
  getMobileFilters,
  filtersContext,
  FormValues,
  FiltersList,
  ParsedFilters,
} from 'api/mobile/filters';
import history from 'utils/history';
import { VehicleInput } from '../MapPage/EntitiesSearch/Modes/VehicleInput';

import { Styled } from './Filters.styles';
import { mainCordovaContext } from '../context';
import { SubmitOnEveryChange } from '../components/SubmitOnEveryChange';
import { Page } from '../components/Page';
import {LogoutButton, NavigationButton} from '../components/NavigationButton';

const Filters: React.FC = () => {
  const [filters, setFilters] = useState<FiltersList>({
    branches: [],
    depots: [],
    vehicles: [],
    routes: [],
    date: null,
  });
  const [parsedFilters, setParsedFilters] = useState<ParsedFilters>({
    vehicles: [],
    routes: [],
    depots: [],
    branches: [],
    transporttypes: [],
    gosNomer: [],
  });

  useEffect(() => {
    const getFilters = async () => {
      const data = await getMobileFilters();
      console.log(data);
      if (data) {
        setFilters(data.filters);
        setParsedFilters(data.parsedFilters);
      }
    };
    getFilters();
  }, []);

  return (
    <Page primaryButtonNode={<NavigationButton />} title="Поиск ТС" actionButton={<LogoutButton />}>
      <Styled.BodyWrapper>
        <Formik<FormValues>
          initialValues={{
            route: [],
            branch: [],
            vehicle: [],
            routeType: [],
            gosNomer: [],
          }}
          onSubmit={(values) => {}}
        >
          {({ values }) => (
            <filtersContext.Provider
              value={
                {
                  parsedFilters,
                  filters,
                } as any
              }
            >
              <SubmitOnEveryChange />
              <Stack
                styles={{
                  root: { width: 'calc(100vw - 52px)', minHeight: '550px' },
                }}
                tokens={{ childrenGap: 16 }}
              >
                <StackItem>
                  <VehicleInput name="branch" label="Филиал" />
                </StackItem>
                <StackItem>
                  <VehicleInput name="route" label="Маршрут" />
                </StackItem>
                <StackItem>
                  <VehicleInput name="routeType" label="Вид ТС" />
                </StackItem>
                <StackItem>
                  <VehicleInput
                    name="vehicle"
                    label="Гаражный номер"
                    singleSelection
                  />
                </StackItem>
              </Stack>
              <Styled.MobileBtn>
                <PrimaryButton
                  styles={{
                    root: {
                      borderRadius: '300px',
                      width: '100px',
                      height: '100px',
                      selectors: {
                        '&:disabled': {
                          background: '#E9E9E9',
                        },
                      },
                    },
                  }}
                  onClick={() =>
                    values.vehicle[0] &&
                    history.push(`/video/${values.vehicle[0]}`)
                  }
                  disabled={!values.vehicle[0]}
                >
                  Смотреть видео
                </PrimaryButton>
              </Styled.MobileBtn>
            </filtersContext.Provider>
          )}
        </Formik>
      </Styled.BodyWrapper>
    </Page>
  );
};

export default Filters;
